var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.861,
    height: 19.694,
    viewBox: "0 0 15.861 19.694",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#cbcbd1;opacity:0.8;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.93,19.694c-.941,0-2.88-1.889-4.716-4.593C1.2,12.135,0,9.267,0,7.43A7.7,7.7,0,0,1,7.93,0a7.7,7.7,0,0,1,7.931,7.43c0,1.837-1.2,4.7-3.215,7.671C10.81,17.806,8.871,19.694,7.93,19.694Zm0-15.979A3.85,3.85,0,0,0,3.965,7.43,3.85,3.85,0,0,0,7.93,11.146,3.85,3.85,0,0,0,11.9,7.43,3.85,3.85,0,0,0,7.93,3.715Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarker);
export default __webpack_public_path__ + "static/media/location-marker.11d8aac09610e1a64adf092c3ff1dcbe.svg";
export { ForwardRef as ReactComponent };